














import { Component, Vue } from "vue-property-decorator";
import { logout } from "@/req/user";
import disContent from "./disContent.vue";
import disFeature from "./disFeature.vue";
@Component({
  components: { disContent, disFeature },
})
export default class Logout extends Vue {}
